import { ArrowLeft } from 'lucide-react';

export default function AdminToolsBackToolbar() {
  return (
    <div className="Admin-daily-question-toolbar">
      <button
        type="button"
        className="Button Dashboard-chat-btn ForumPage-back-btn"
        title="Takaisin hallintaan"
        aria-label="Takaisin hallintaan"
        onClick={() => {
          window.location.href = '/admin';
        }}
      >
        <ArrowLeft size={22} strokeWidth={2} aria-hidden />
      </button>
    </div>
  );
}
